import { Link } from "react-router-dom";

export default function Logo({ compact = false }) {
  return (
    <Link to="/" className="group flex items-center gap-3" data-testid="brand-logo" aria-label="Operating Reality — home">
      <span className="relative block h-9 w-9 shrink-0">
        <span className="absolute left-0 top-0 h-6 w-6 rounded-full border-[3.5px] border-slate-100 transition-colors duration-300 group-hover:border-glow" />
        <span className="absolute bottom-0 right-0 font-sans text-xl font-semibold leading-none text-glow">
          R
        </span>
      </span>
      {!compact && (
        <span className="hidden flex-col leading-tight sm:flex">
          <span className="font-mono text-[10px] uppercase tracking-[0.32em] text-slate-300">
            Operating
          </span>
          <span className="font-mono text-[10px] uppercase tracking-[0.32em] text-glow">
            Reality
          </span>
        </span>
      )}
    </Link>
  );
}
